"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
require("./loader.component.scss");
var LoaderComponent = /** @class */ (function () {
    function LoaderComponent() {
        this.isLoading = false;
        this.size = 1;
    }
    LoaderComponent.prototype.ngOnInit = function () {
    };
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Object)
    ], LoaderComponent.prototype, "isLoading", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Object)
    ], LoaderComponent.prototype, "size", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", String)
    ], LoaderComponent.prototype, "message", void 0);
    LoaderComponent = tslib_1.__decorate([
        core_1.Component({
            selector: 'app-loader',
            template: require('./loader.component.html')
        }),
        tslib_1.__metadata("design:paramtypes", [])
    ], LoaderComponent);
    return LoaderComponent;
}());
exports.LoaderComponent = LoaderComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9hZGVyLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImxvYWRlci5jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsc0NBQXlEO0FBRXpELG1DQUFpQztBQU1qQztJQU1JO1FBSlMsY0FBUyxHQUFHLEtBQUssQ0FBQztRQUNsQixTQUFJLEdBQUcsQ0FBQyxDQUFDO0lBSWxCLENBQUM7SUFFRCxrQ0FBUSxHQUFSO0lBQ0EsQ0FBQztJQVJRO1FBQVIsWUFBSyxFQUFFOztzREFBbUI7SUFDbEI7UUFBUixZQUFLLEVBQUU7O2lEQUFVO0lBQ1Q7UUFBUixZQUFLLEVBQUU7O29EQUFpQjtJQUpoQixlQUFlO1FBSjNCLGdCQUFTLENBQUM7WUFDUCxRQUFRLEVBQUUsWUFBWTtZQUN0QixRQUFRLEVBQUUsT0FBTyxDQUFDLHlCQUF5QixDQUFDO1NBQy9DLENBQUM7O09BQ1csZUFBZSxDQVkzQjtJQUFELHNCQUFDO0NBQUEsQUFaRCxJQVlDO0FBWlksMENBQWUifQ==


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loader/loader.component.ts
// module id = 628
// module chunks = 0